export const columnOrder = [
  { label: 'Shipment ID', key: 'id', size: 'col-md-1' },
  { label: 'Pickup Date', key: 'pickups', size: 'col-md-2', sortable: true },
  { label: 'Pickup', key: 'pickup', size: 'col-md-2' },
  { label: 'Delivery', key: 'delivery', size: 'col-md-3' },
  { label: 'Status', key: 'status', size: 'col-md-2' },
  { label: 'Dispatcher', key: 'dispatcher', size: 'col-md-1' },
  { label: 'Driver', key: 'driver', size: 'col-md-1' },
]
